import { TIER_CONFIGS, IMPROVEMENT_POINTS } from './constants';
import { type CalculatorInputs, type CalculationResult, type TierResult } from './types';

export function calculate(inputs: CalculatorInputs): CalculationResult {
  const { workforceType, totalEmployees, averageSalary, turnoverRate } = inputs;
  const tiers = TIER_CONFIGS[workforceType];
  const totalDepartures = totalEmployees * (turnoverRate / 100);
  const improvementPoints = IMPROVEMENT_POINTS[workforceType];

  const tierResults: TierResult[] = tiers.map((tier) => {
    const tierSalary = averageSalary * tier.salaryRatio;
    const departures = Math.round(totalDepartures * (tier.departurePercent / 100));
    const replacementCost = Math.round(tierSalary * tier.replacementMultiplier);
    const replacementPercent = Math.round(tier.replacementMultiplier * 100);
    const annualTotal = departures * replacementCost;

    return {
      label: tier.label,
      departures,
      salary: Math.round(tierSalary),
      replacementCost,
      replacementPercent,
      annualTotal,
    };
  });

  const roundedTotalDepartures = tierResults.reduce((sum, t) => sum + t.departures, 0);
  const totalCost = tierResults.reduce((sum, t) => sum + t.annualTotal, 0);
  const avoidableDepartures = Math.round(totalEmployees * (improvementPoints / 100));
  const blendedCostPerPerson = roundedTotalDepartures > 0 ? totalCost / roundedTotalDepartures : 0;
  const avoidableSaving = Math.round(avoidableDepartures * blendedCostPerPerson);

  return {
    totalDepartures: roundedTotalDepartures,
    totalCost,
    tiers: tierResults,
    avoidableDepartures,
    avoidableSaving,
    improvementPoints,
    blendedCostPerPerson,
  };
}
